module.exports = "/_next/static/images/b87522716c07f6b73f35820438b53d1a-mastercard-left-small.jpg.webp";